import { render, staticRenderFns } from "./scoreComponentEntry.vue?vue&type=template&id=ddcf9664&scoped=true&"
import script from "./scoreComponentEntry.vue?vue&type=script&lang=js&"
export * from "./scoreComponentEntry.vue?vue&type=script&lang=js&"
import style0 from "./scoreComponentEntry.vue?vue&type=style&index=0&id=ddcf9664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcf9664",
  null
  
)

export default component.exports